// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1icNw","icon":"SortAdornment_icon__1Q5QO","up":"SortAdornment_up__1DPPp","down":"SortAdornment_down__1fmjI","active":"SortAdornment_active__1fktq"};